module.exports = __webpack_public_path__ + "static/img/AC4136502.70222df9.jpg";